export const initialState = {
  locale: 'en',
  location: {},
  possibleLanguages: [],
  categories: {},
  categoriesMap: {},
  categoriesLegacyMap: {},
  servicesMap: {},
  servicesLegacyMap: {},
  arenaUserInfo: {},
  userInfo: {},
  staticsBaseUrl: '',
  url: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
